export default "__VITE_ASSET__S8D3L$qR__"